var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2",style:({ backgroundColor: 'green', display: 'inline-flex' }),attrs:{"small":"","icon":""}},[_c('v-icon',{attrs:{"size":"small","color":"white"}},[_vm._v("mdi mdi-square-edit-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }